var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { defineMessages, injectIntl } from "react-intl";
import Menu from "./../info/termsAndConditions/shared/Menu";
var messages = defineMessages({
    title: {
        id: "content.regulations.kycPolicy.title",
        defaultMessage: "Идентификация и верификация клиента (KYC)",
    },
    intro: {
        id: "content.regulations.kycPolicy.intro",
        defaultMessage: "fp.gold имеет право проводить верификацию клиента по своему усмотрению. Клиент должен связаться со Службой поддержки, чтобы пройти процесс верификации.",
    },
    purpose: {
        id: "content.regulations.kycPolicy.purpose",
        defaultMessage: "Целью процесса верификации является определение принадлежности ставок и/или учетных записей, зарегистрированных на веб-сайте fp.gold, конкретному лицу. В целях верификации fp.gold вправе запросить у клиента любые данные, в том числе:",
    },
    proofOfId: {
        id: "content.regulations.kycPolicy.proofOfId",
        defaultMessage: "Удостоверение личности (в некоторых случаях лицевая и обратная сторона в зависимости от документа).",
    },
    selfie: {
        id: "content.regulations.kycPolicy.selfie",
        defaultMessage: "Селфи себя, держащего документ с листком бумаги, на котором написаны текущая дата и время.",
    },
    bankStatement: {
        id: "content.regulations.kycPolicy.bankStatement",
        defaultMessage: "Выписка с банковского счета.",
    },
    refusal: {
        id: "content.regulations.kycPolicy.refusal",
        defaultMessage: "В случае отказа предоставить запрошенные данные для верификации, fp.gold оставляет за собой право ограничить игрока в размещении ставок и получении выплаты.",
    },
    processTime: {
        id: "content.regulations.kycPolicy.processTime",
        defaultMessage: "Процесс KYC не должен занимать более 48 часов, однако fp.gold оставляет за собой право продлить 48-часовой период, если fp.gold сочтет необходимым осуществить процесс KYC в полном объеме для выполнения требований регулирующего органа.",
    },
});
var KycPolicy = /** @class */ (function (_super) {
    __extends(KycPolicy, _super);
    function KycPolicy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KycPolicy.prototype.render = function () {
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme;
        var title = intl.formatMessage(messages.title);
        var textColor = darkTheme ? "#fff" : "#000";
        return (_jsx(Fragment, { children: _jsxs("div", __assign({ className: "content" }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { name: "description", content: title })] }), _jsxs("div", __assign({ className: "blc_faq" }, { children: [_jsx(Menu, {}), _jsxs("div", __assign({ className: "desc", style: { backgroundColor: darkTheme ? "#3d3d3d" : "#fff" } }, { children: [_jsx("h1", __assign({ style: {
                                            fontSize: 18,
                                            fontWeight: "bold",
                                            marginBottom: 16,
                                            lineHeight: "1.5",
                                            color: textColor,
                                        } }, { children: title })), _jsx("p", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.intro) })), _jsx("p", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.purpose) })), _jsxs("ul", __assign({ style: {
                                            listStyleType: "disc",
                                            paddingLeft: 20,
                                            marginBottom: 10,
                                            color: textColor,
                                        } }, { children: [_jsx("li", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.proofOfId) })), _jsx("li", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.selfie) })), _jsx("li", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.bankStatement) }))] })), _jsx("p", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.refusal) })), _jsx("p", __assign({ style: { color: textColor } }, { children: intl.formatMessage(messages.processTime) }))] }))] }))] })) }));
    };
    return KycPolicy;
}(Component));
KycPolicy.propTypes = {
    intl: PropTypes.object.isRequired,
    darkTheme: PropTypes.bool,
};
var mapStateToProps = function (state) { return ({
    darkTheme: state.application.get("darkTheme"),
}); };
export default connect(mapStateToProps)(injectIntl(KycPolicy));



// WEBPACK FOOTER //
// ./src/components/staticContent/KycPolicy.jsx